module.exports = __webpack_public_path__ + "img/10.af59e153.jpg";